import api from '..'

const canCourse = (courseId: number | string) => {
  return api.get(`admin/can_course/${courseId}`)
}

export default canCourse
